import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'auto' // 'auto' is the type-safe way to say 'instant'
    });
  }, [pathname]); 

  return null;
};

export default ScrollToTop;